import { render, staticRenderFns } from "./kalemmuze.vue?vue&type=template&id=f958e654"
import script from "./kalemmuze.vue?vue&type=script&lang=js"
export * from "./kalemmuze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports